import { useState } from 'react';

export type ScheduleActiveDragType =
  | 'slot'
  | 'scene'
  | 'wholeDay'
  | 'clipboard'
  | 'clipboardGroup'
  | null;
export type ScheduleActiveSortingType = 'slot' | null;
export type ScheduleActiveSortingDragLevel = 'slot' | 'note' | null;

export function useScheduleDnDState() {
  const [activeDragId, setActiveDragId] = useState<string | null>(null);
  const [activeDragType, setActiveDragType] = useState<ScheduleActiveDragType>(null);
  const [activeDragData, setActiveDragData] = useState<any>(null);
  const [shouldHideDragOverlay, setShouldHideDragOverlay] = useState(false);
  const [dragOverDateCell, setDragOverDateCell] = useState<string | null>(null);
  const [, setSourceDateCell] = useState<string | null>(null);
  const [disabledDateCells, setDisabledDateCells] = useState<Set<string>>(new Set());
  const [activeSortingId, setActiveSortingId] = useState<string | null>(null);
  const [activeSortingType, setActiveSortingType] = useState<ScheduleActiveSortingType>(null);
  const [activeSortingDate, setActiveSortingDate] = useState<string | null>(null);
  const [activeSortingDragLevel, setActiveSortingDragLevel] = useState<ScheduleActiveSortingDragLevel>(null);
  const [invalidDropTargets, setInvalidDropTargets] = useState<Set<string>>(new Set());
  const [wholeDayOverlayWidth, setWholeDayOverlayWidth] = useState<number | null>(null);
  const [slotOverlayWidth, setSlotOverlayWidth] = useState<number | null>(null);
  const [sceneDragOverlayWidth, setSceneDragOverlayWidth] = useState<number | null>(null);
  const [calendarInsertHighlight, setCalendarInsertHighlight] = useState<{
    dateStr: string;
    insertIndex: number;
  } | null>(null);
  const [activeSlotDragBundleIds, setActiveSlotDragBundleIds] = useState<string[] | null>(null);

  return {
    dndState: {
      activeDragId,
      activeDragType,
      activeDragData,
      shouldHideDragOverlay,
      dragOverDateCell,
      disabledDateCells,
      activeSortingId,
      activeSortingType,
      activeSortingDate,
      activeSortingDragLevel,
      invalidDropTargets,
      wholeDayOverlayWidth,
      slotOverlayWidth,
      sceneDragOverlayWidth,
      calendarInsertHighlight,
      activeSlotDragBundleIds,
    },
    dndSetters: {
      setActiveDragId,
      setActiveDragType,
      setActiveDragData,
      setShouldHideDragOverlay,
      setDragOverDateCell,
      setSourceDateCell,
      setDisabledDateCells,
      setActiveSortingId,
      setActiveSortingType,
      setActiveSortingDate,
      setActiveSortingDragLevel,
      setInvalidDropTargets,
      setWholeDayOverlayWidth,
      setSlotOverlayWidth,
      setSceneDragOverlayWidth,
      setCalendarInsertHighlight,
      setActiveSlotDragBundleIds,
    },
  };
}

